module.exports = {
  factory: function ghosts() {
    return [];
  },
  reset: function(ghosts) {
    ghosts.length = 0;
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/ghosts.js
// module id = 193
// module chunks = 0